import React, { useState, useRef, useEffect } from "react";
import Search from "../other-icons/Search";

import "./election-constituency-search-bar.m.css";

function ElectionConstituencySearchBar({ Records = [] }) {
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const modalRef = useRef(null);

  const handleChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    const filteredrecords = Records.filter((item) => item.constituencyName.toLowerCase().includes(value.toLowerCase()));
    setFilteredRecords(filteredrecords);
  };

  useEffect(() => {
    const clikedOutsideModal = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModalOpen(false);
      }
    };
    document.addEventListener("mousedown", clikedOutsideModal);
    return () => document.removeEventListener("mousedown", clikedOutsideModal);
  }, [modalRef]);

  return (
    <div styleName="search-wrapper">
      <div styleName="search-container" className="search-container">
        <input
          placeholder="Search Your Constituency"
          type="text"
          styleName="search-input-box"
          className="search-input-box"
          value={inputValue}
          onChange={handleChange}
        />
        <button styleName="search-btn">
          <Search color="black" height="12px" width="12px" />
        </button>
      </div>
      <div styleName="dropdown" ref={modalRef}>
        {inputValue.length > 0 &&
          (filteredRecords.length > 0 ? (
            filteredRecords.slice(0, 5).map((item, index) => (
              <a href={item?.publishedUrl} target="_blank" key={item?.id}>
                <div styleName="dropdown-item">{item?.secondarySection}</div>
              </a>
            ))
          ) : (
            <div styleName="dropdown-item-not-found">No Constituency found</div>
          ))}
      </div>
    </div>
  );
}

export default ElectionConstituencySearchBar;
